/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';

function WarningFilledIcon(props, svgRef) {
  return React.createElement("svg", Object.assign({
    "data-sanity-icon": "warning-filled",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7728 5.35558C13.7822 3.57248 11.2178 3.57247 10.2272 5.35558L3.62622 17.2373C2.66345 18.9703 3.91657 21.1 5.89903 21.1H19.101C21.0834 21.1 22.3365 18.9703 21.3738 17.2373L14.7728 5.35558ZM13 16V17.5H12V16H13ZM12 10.4999V14.5H13V10.4999H12Z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(WarningFilledIcon);
export default ForwardRef;